import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Maps from "../Maps";

const FooeterWrapper = styled.div`
  background: #311b92;
  height: fit-content;
  h2 {
    line-height: 1.5rem;
  }
  ul li a {
    color: #fff;
    font-size: 0.9rem;
  }
`;

export default () => (
  <FooeterWrapper className="pt3">
    <div className="columns is-multiline is-mobile is-centered ph7-l pa3">
      <div className="column">
        <h2 className="f5 fw6 white mb2">Policies</h2>
        <p className="white f6">
          Copyright © 2018 Defence Space Administration
        </p>
      </div>

      <div className="column">
        <h2 className="f5 fw6 white mb2">Main Menu</h2>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About DSA</Link>
          </li>
          <li>
            <Link to="/how-it-works">How to Apply</Link>
          </li>
          <li>
            <Link to="/faq">FAQ</Link>
          </li>
          <li>
            <Link to="/vacancies">Vacancies</Link>
          </li>
        </ul>
      </div>

      <div className="column is-6">
        <h2 className="f5 fw6 white mb2">Our Office</h2>
        <Maps isMarkerShown={true} />
      </div>
    </div>
  </FooeterWrapper>
);



// WEBPACK FOOTER //
// ./src/components/common/Footer.js